import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export default function BackdropLoader({loader}:any) {
  return (
    <div>
      <Backdrop sx={{ color: "#fff", zIndex: "9999" }} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
